/**
 * <card-variant-picker>
 *
 * Inline variant picker used inside product cards on collection pages.
 * Picking an option value writes the matching variant id into the form's
 * hidden "id" input and enables the submit button. The actual add-to-cart
 * is handled by the theme's own <product-form> element wrapping the form.
 */
class CardVariantPicker extends HTMLElement {
  connectedCallback() {
    this.variantInput = this.querySelector('[data-variant-input]');
    this.submitButton = this.querySelector('[data-submit-button]');
    this.submitLabel = this.querySelector('[data-submit-label]');
    this.selectedLabel = this.querySelector('[data-selected-label]');
    this.options = Array.from(this.querySelectorAll('[data-variant-option]'));

    if (!this.variantInput || !this.submitButton || this.options.length === 0) return;

    this.defaultLabel = this.submitLabel ? this.submitLabel.textContent.trim() : '';
    this.optionName = this.selectedLabel
      ? this.selectedLabel.querySelector('.card-variant-picker__option-name')
      : null;
    this.optionNameText = this.optionName ? this.optionName.textContent.trim() : '';

    this.onOptionChange = this.onOptionChange.bind(this);

    this.options.forEach((option) => {
      option.addEventListener('change', this.onOptionChange);
    });

    // A previously checked option can survive a section re-render.
    const preselected = this.options.find((option) => option.checked);
    if (preselected) this.applySelection(preselected);
  }

  disconnectedCallback() {
    this.options?.forEach((option) => {
      option.removeEventListener('change', this.onOptionChange);
    });
  }

  onOptionChange(event) {
    this.applySelection(event.currentTarget);
  }

  applySelection(option) {
    if (!option || option.disabled) return;

    this.variantInput.value = option.value;
    this.submitButton.disabled = false;

    if (this.selectedLabel && this.optionName) {
      const valueName = option.dataset.valueName || '';
      this.selectedLabel.textContent = '';
      this.selectedLabel.appendChild(this.optionName);
      if (valueName) {
        this.selectedLabel.appendChild(document.createTextNode(' · ' + valueName));
      }
    }
  }
}

if (!window.customElements.get('card-variant-picker')) {
  window.customElements.define('card-variant-picker', CardVariantPicker);
}
